import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import theme from "../../theme";
import GraficCard from "../../components/form/formComponents/GraphicCard";
import CalculateIcon from "@mui/icons-material/Calculate";
import OnlinePredictionIcon from "@mui/icons-material/OnlinePrediction";
import {
  PieChart,
  Tooltip,
  Cell,
  LineChart,
  BarChart,
  XAxis,
  YAxis,
  Line,
  CartesianGrid,
  ResponsiveContainer,
  Bar,
  Brush,
  ReferenceArea,
  Area,
  ReferenceDot,
} from "recharts";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import { Fullscreen } from "@material-ui/icons";
const BalanceConsumGraph = ({ unit }) => {
  const { t } = useTranslation();
  const balanceValues = useSelector(
    (state) => state?.balanceSlice?.balanceValues
  );
  const headerAppBarOpen = useSelector(
    (state) => state?.utilsSlice?.headerAppBarOpen
  );
  const data = balanceValues?.map((item) => ({
    date: t("date_val", { val: new Date(item?.date) }),
    valueIn: item?.in_meter_sum,
    valueOut: item?.out_meter_sum,
    computed: item?.computed,
  }));

  return (
    <>
      {balanceValues?.length > 0 && (
        <LineChart
          width={headerAppBarOpen ? 1500 : 1775}
          height={530}
          margin={{
            left: 0,
            top: 10,
            right: 30,
          }}
          data={data}
        >
          <Tooltip
            content={({ active, payload, label }) => {
              const clen = payload;

              return (
                <GraficCard
                  width={250}
                  color1={"#edb211"}
                  color2={"#0781d9"}
                  value={`${t("incoming_consumption")}: ${t("number", {
                    val: payload?.[0]?.payload?.valueIn,
                    maximumFractionDigits: 3,
                  })}`}
                  value2={`${t("outgoing_consumption")}: ${t("number", {
                    val: payload?.[0]?.payload?.valueOut,
                    maximumFractionDigits: 3,
                  })}`}
                  icon={
                    payload?.[0]?.payload.computed === true ? (
                      <OnlinePredictionIcon
                        fontSize="large"
                        sx={{ fill: "#8884d8" }}
                      />
                    ) : (
                      <CalculateIcon fontSize="large" sx={{ fill: "green" }} />
                    )
                  }
                  date={payload?.[0]?.payload?.date}
                />
              );
            }}
          />

          <Tooltip
            labelFormatter={(value) => value}
            formatter={(value) => t("number", { val: value })}
          />

          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            label={{ value: t("date"), position: "insideBottom", offset: 5 }}
            dataKey="date"
            angle={45}
            interval="preserveStartEnd"
            height={90}
            stroke={theme.palette.group_and_district.main}
            tickMargin={30}
            tickFormatter={(value) => {
              return value;
            }}
          />

          <YAxis
            type="number"
            label={{
              value: unit,
              angle: -45,
              position: "insideLeft",
            }}
            style={{ fontSize: "10px" }}
            stroke={theme.palette.group_and_district.main}
          />
          <Line
            type="monotone"
            dataKey="valueIn"
            name={t("incoming_consumption")}
            stroke="#edb211"
            isAnimationActive={false}
          />
          <Line
            type="monotone"
            name={t("outgoing_consumption")}
            dataKey="valueOut"
            stroke="#0781d9"
            isAnimationActive={false}
          />
        </LineChart>
      )}
      {balanceValues?.length < 1 && (
        <Typography variant="h4" align="center">
          {t("no_available_data")}
        </Typography>
      )}
    </>
  );
};

export default BalanceConsumGraph;
